<div class="page-container">
  @if(isLoading){
  <app-text size="l" weight="m" color="gray-900">
    資料載入中......
  </app-text>
  }@else{
  @if (!isShowReservation) {
  <!-- 無預約資料頁面 -->
  <app-new-member-center-no-data
    [cellSaveLater]="cellSaveLater"
  ></app-new-member-center-no-data>

  }@else {
  <!-- 時間資訊卡 -->
  <div class="flex-column-flex-start">

    @if (isCompleted){
    <div class="flex-row-space-between member-green-completed-card">
      <div class="flex-column-flex-start">
        <app-text size="l" weight="m" color="gray-900">
          您的健康檢查已完成！
        </app-text>
        <app-text size="m" weight="s" color="gray-900">
          完整檢查報告約於 14-21 個工作天後產出，請耐心等候。
        </app-text>
      </div>
      <!-- @if (!isProdEnvironment) { -->
      <div class="go-report-btn">
        <app-tag size="md" color="filled-dark-green" (clicked)="goMyprofile()" [clickable]="true">
          <app-text size="m" weight="m" color="gray-0">查看我的健檢報告</app-text>
        </app-tag>
      </div>
      <!-- } -->
    </div>

    }@else if (isExpired){
    <div class="flex-row-flex-start member-green-expired-card">
      <img src="/assets/img/member-expired-alert-circle.svg" alt="expired-alert">
      <div class="flex-column-flex-start">
        <app-text size="l" weight="m" color="Primary-800">
          您的健檢預約已過期，請重新安排時間
        </app-text>
        <app-text size="m" weight="s" color="gray-900">
          檢查日前如有身體狀況有改變 (氣喘發作、懷孕等)，請提前來電聯絡客服中心 (02)412-8006，以利重新評估檢查安排。
        </app-text>
      </div>
    </div>


    }@else{
    <!-- <app-text size="l" weight="m" color="gray-900" class="padding-8">
      Hi，您的健檢資訊如下
    </app-text> -->
    }

    <!-- 個人資料卡片 -->
    <div class="profile-card">
      <div class="profile-info">
        <div class="profile-info-title">
          <app-tag size="healthProfile" color="filled-green">
            <app-text size="s" weight="m" color="primary-700">基本資料</app-text>
          </app-tag>
          <button
            type="button"
            class="btn-text-primary btn-toggle-visibility"
            (click)="toggleProfileVisibility()"
            [attr.aria-label]="isProfileVisible ? '隱藏基本資料' : '顯示基本資料'"
          >
            <img
              width="20"
              height="20"
              [src]="isProfileVisible ? 'assets/img/i-eye.svg' : 'assets/img/i-eye-closed.svg'"
              alt=""
            />
          </button>
        </div>
        @if (isProfileVisible) {
          <app-text size="extra" weight="xl" color="primary-600">
            {{ userName }}
          </app-text>
        } @else {
          <div class="profile-name-mask" aria-hidden="true">
            @for (dot of maskDots; track $index) {
              <img width="13.03" height="13.09" src="assets/img/logo-cover.svg" alt="" />
            }
          </div>
        }
      </div>
    </div>

    <div class="member-center-header">
      <div class="header-content">
        <div class="reservation-time-card">
          <app-tag size="sm" color="filled-green">
            <app-text size="s" weight="s" color="primary-700">健康檢查</app-text>
          </app-tag>

          <div class="flex-row-flex-start" [class.opacity-50]="isBookDatePast()">
            <div class="card-day-area">
              <app-text size="xl" weight="xl" color="primary-600" font="en">{{ (bookData?.bookDate ?? '') |
                month}}</app-text>
              <app-text size="xl" weight="xl" color="primary-600" font="en">/</app-text>
              <app-text size="xxl" weight="xl" color="primary-600" font="en">{{ (bookData?.bookDate ?? '') |
                day}}</app-text>
            </div>

            <div class="flex-column-flex-start">
              <app-text size="s" weight="s" color="gray-600">{{ (bookData?.bookDate ?? '') | weekday}}</app-text>
              <app-text size="l" weight="m" font="en">{{ (bookData?.bookTime ?? '') | timePeriod}}</app-text>
            </div>
          </div>

          <div class="flex-row-space-between padding-16 card-content-green card-content-mobile">
            <div class="flex-row-flex-start">
              <img src="/assets/img/member-health-check-location.png" alt="health-check-location">
              <div class="flex-column-flex-start">
                <app-text size="l" weight="m">{{ bookData?.orgName }}</app-text>
                <app-text size="s" weight="s" color="gray-900">{{ bookData?.orgAddress }}</app-text>
              </div>
            </div>

            <app-tag size="md" color="filled-dark-green" [clickable]="true" (clicked)="goNavigation()">
              <app-text size="xs" weight="m" color="gray-0">前往導航</app-text>
              <img src="/assets/img/member-arrow-white.svg" alt="arrow-right">
            </app-tag>
          </div>

          <!-- 營養諮詢 -->
          @if(bookData?.nutBookDate){
          <div class="flex-row-flex-start card-content-gray"
            [class.opacity-50]="isDatePast(bookData?.nutBookDate ?? '')">
            <div class="nutBookTime">
              <img src="/assets/img/member-icon-wrapper.svg" alt="alert">
              <app-text size="m" weight="m" color="primary-800">營養諮詢</app-text>
            </div>
            <app-text size="m" weight="m"> {{ (bookData?.nutBookDate ?? '') | formatDateMMDD }} {{
              (bookData?.nutBookTime ?? '') | timePeriod }} </app-text>
          </div>
          }

          <!-- 待補檢項目，同日期整理在一起 -->
          @if(this.isShowPostponeList){
          <div class="flex-column-flex-start">
            <app-text size="s" weight="m" color="primary-800">待補檢項目</app-text>
            @for (group of groupedArray; track group.bookDate) {
            <div class="flex-row-flex-start-top" [class.opacity-50]="isDatePast(group.bookDate)">

              <!-- 日期 -->
              <div class="card-content-gray-small padding-8">
                <app-text size="s" weight="xl" color="steel-700" font="en">
                  {{ group.bookDate | formatDateMMDD }}
                </app-text>
              </div>

              <!-- 當天項目 -->
              <div class="postponeList">
                @for (item of group.items; track item.examItem) {
                <div class="padding-8">
                  <app-text size="s" weight="m">
                    {{ item.examName }}
                  </app-text>
                </div>

                }
              </div>

            </div>
            }
          </div>
          }
        </div>

        @if(isShowModifyTime){
        <div class="padding-8">
          <app-text size="s" weight="s" color="gray-600">想調整檢查時間?</app-text>
          <app-tag size="none" color="none" [clickable]="true" (clicked)="modifyTime()">
            <app-text size="s" weight="m" color="primary-500" class="modify-time">變更日期</app-text>
          </app-tag>
        </div>
        }

      </div>

      <!-- 若有高階影像 -->
      @if(imageExamCount > 0){
      <div class="header-content">
        <div class="reservation-time-card">
          <div class="flex-row-space-between">
            <app-tag size="sm" color="filled-gray">
              <app-text size="s" weight="m" color="gray-700">合作醫院檢查 : {{ imageExamCount }} 項</app-text>
            </app-tag>

            <app-tag size="sm" color="outline-orange">
              <img src="/assets/img/member-image-book-alert.svg" alt="alert">
              <app-text size="s" weight="m" color="orange-500">與健康檢查不同地點</app-text>
            </app-tag>
          </div>

          <!-- 若只有一個高階影像 -->
          @if (imageExamCount === 1) {
          @if (singleImageBookItem; as item) {
          <!-- ===== 單筆顯示 ===== -->
          <div class="flex-row-flex-start" style="flex-direction:column;align-items: flex-start;gap: 8px;"
            [class.opacity-50]="isDatePast(groupedImageBooks[0].bookDate ?? '')">

            @if(this.isImageBookDateHasNull){
            <app-text size="l" weight="m" font="zh">
              本中心將為您安排日期
            </app-text>
            <app-text size="s" weight="m" font="zh" color="gray-500">
              請留意簡訊（或改以 Email）或電話通知</app-text>
            }@else {
            <!-- 日期 -->
            <div class="card-day-area">
              <app-text size="xl" weight="xl" color="orange-500" font="en">
                {{ groupedImageBooks[0].bookDate | month }}
              </app-text>
              <app-text size="xl" weight="xl" color="orange-500" font="en">/</app-text>
              <app-text size="xxl" weight="xl" color="orange-500" font="en">
                {{ groupedImageBooks[0].bookDate | day }}
              </app-text>
            </div>
            }

            <!-- 時間 -->
            <app-text size="l" weight="m" font="en">
              {{ item.imageBookTime }}
            </app-text>

          </div>

          <!-- 卡片 -->
          <div class="flex-row-space-between padding-16 card-content-orange">
            <div class="flex-row-flex-start">
              <img src="/assets/img/member-image-book-location.png" alt="health-check-location">

              <div class="flex-column-flex-start">
                <app-text size="m" weight="m" color="orange-500">
                  {{ item.imageExamName }}
                </app-text>

                <app-text size="m" weight="m">
                  {{ item.imageBookHospital }}
                </app-text>
              </div>
            </div>
          </div>
          }
          } @else {

          <!-- 若多個高階影像，同日期的整理在一起 -->

          <!-- 若任其一沒有日期 -->
          @if(this.isImageBookDateHasNull){
          <app-text size="l" weight="m" font="zh">
            將由專人致電確認時間
          </app-text>
          }

          @for (group of groupedImageBooks; track group.bookDate) {
          <div class="flex-row-flex-start-top" [class.opacity-50]="isDatePast(group.bookDate)">

            <!-- 日期 -->
            <div class="card-content-gray-small">
              <app-text size="s" weight="xl" color="steel-700" font="en">
                {{ group.bookDate | formatDateMMDD }}
              </app-text>
            </div>

            <!-- 當天影像檢查 -->
            <div class="flex-column-flex-start">
              @for (item of group.items; track item.imageExamItem) {
              <app-text size="m" weight="m" color="orange-500">
                {{ item.imageExamName }}
              </app-text>
              <app-text size="s" weight="m">
                {{ item.imageBookHospital }}
              </app-text>
              <app-text size="s" weight="m">
                {{ item.imageBookTime }}
              </app-text>
              }
            </div>

          </div>
          }

          }

        </div>
      </div>
      }
    </div>
  </div>

  <!-- 同意書/問卷 -->
  @if(isShowQuestionnaire){
  <div class="agreenment-card">
    <div class="agreenment-card-content">
      <app-text size="m" weight="m" color="gray-900">提前完成問卷，報到更順暢</app-text>

      <div class="flex-row-flex-start">
        @if (completedCount() === sortedQuestionnaireStatusList.length && sortedQuestionnaireStatusList.length > 0) {
        <!-- 若全部完成 -->
        <img src="/assets/img/member-complete-state.svg" alt="alert">
        <app-text size="s" weight="s" color="gray-900">已完成</app-text>
        } @else {
        <!-- 進度條 -->
        <app-text size="s" weight="s"
          color="gray-900">{{completedCount()}}/{{sortedQuestionnaireStatusList.length}}</app-text>
        <div class="progress-bar">
          <mat-progress-bar mode="determinate" [value]="percentValue()"></mat-progress-bar>
        </div>

        }
      </div>
    </div>
    <hr>
    @for (item of sortedQuestionnaireStatusList; track item.questionnaireTypeId) {
    <div class="agreenment-card-content">
      <div class="flex-row-flex-start">
        <!-- 打勾與不勾 -->
        @if (item.status === '1'){
        <img src="/assets/img/member-undone-radio.svg" alt="undone">
        }
        <!-- 健調表未完成可修改 -->
        @else if (item.questionnaireTypeId === '3'&& item.status === '4'){
        <img src="/assets/img/member-undone-radio.svg" alt="undone">
        }
        @else{
        <img src="/assets/img/member-complete-radio.svg" alt="complete">
        }

        <!-- 標題 -->
        <app-text size="m" weight="s" color="gray-900">{{ item.questionnaireName }}</app-text>

        <!-- 狀態標籤(僅健調表在用) -->
        @if (item.questionnaireTypeId === '3' && this.diffDays > 10) {
        <app-tag size="sm" color="outline-blue">
          <app-text [size]="isMobile ? 'xxxs' : 's'" weight="m" color="blue-600">健檢日前十天開放</app-text>
        </app-tag>
        }
        @if (item.questionnaireTypeId === '3' && this.diffDays <= 10 && item.status==='4' ) { <app-tag size="sm"
          color="outline-red">
          <app-text size="s" weight="m" color="red-600">未完成</app-text>
          </app-tag>
          }
      </div>

      @if (item.status === '1') {
      @if(item.questionnaireTypeId === '3' && this.diffDays > 10){
      <!--健康調查表大於10天顯示尚未開放 -->
      <app-tag size="md" color="filled-gray" [clickable]="false">
        <app-text size="m" weight="m" color="gray-300">尚未開放</app-text>
      </app-tag>
      }@else {
      <app-tag size="md" color="filled-dark-green" [clickable]="true"
        (clicked)="goQuestionnaire(item.questionnaireTypeId)">
        <app-text size="m" weight="m" color="gray-0">立即填寫</app-text>
      </app-tag>
      }
      } @else if (item.status === '3' || item.status === '4' ) {
      @if (item.questionnaireTypeId === '3' && this.diffDays <= 10) { <!-- // 健調表在檢查日前10天內（含當天及健檢後）可修改 -->
        <app-tag size="md" color="outline-green" [clickable]="true"
          (clicked)="goQuestionnaire(item.questionnaireTypeId)">
          <app-text size="m" weight="m" color="primary-500">修改</app-text>
        </app-tag>
        } @else {
        <app-tag size="md" color="outline-green" [clickable]="true"
          (clicked)="goQuestionnaire(item.questionnaireTypeId)">
          <app-text size="m" weight="m" color="primary-500">修改</app-text>
        </app-tag>
        }
        } @else {
        <!-- 已完成將不顯示tag -->
        }
    </div>
    }
  </div>
  }

  <!-- 準備指南/檢查項目/預約資訊區塊 -->
  <div class="member-center-container">
    <!-- Tab 標籤列 -->
    <mat-tab-group [(selectedIndex)]="selectedTab" class="member-center-tabs">
      <mat-tab label="準備指南"></mat-tab>
      <mat-tab label="檢查項目"></mat-tab>
      <mat-tab label="預約資訊"></mat-tab>
    </mat-tab-group>

    <!-- 將 component 移到 tab 外面,只建立一次 -->
    <app-prepare-appointment [isNotWebOpen]="isNotWebOpen"  [cellSaveLater]="cellSaveLater" [selectedTab]="selectedTab"></app-prepare-appointment>
  </div>

  <!-- LINE@ -->
  @if (selectedTab === 0) {
  <div class="line-qrcode-block">
    <div class="line-qrcode-content">
      <div class="line-qrcode-left">
        <img width="120" height="120" ngSrc="assets/img/booking-complete-line@.png" alt="line qr code"
          class="line-qrcode-image" />
      </div>
      <div class="line-qrcode-right">
        <div class="line-text">
          <h3 class="line-title">
            {{ 'line-message.title' | translate }}
          </h3>
          <p class="line-subtitle">
            {{ 'line-message.message' | translate }}
          </p>
        </div>
        <button mat-button class="btn-text-primary line-add-btn" (click)="handleToLine()">
          {{ 'line-message.button-text' | translate }}
        </button>
      </div>
    </div>
  </div>
  }
  }
  }
</div>